import o from "./Body.js";
import t from "./BottomSheet.js";
import r from "./Footer.js";
import e from "./Header.js";
import m from "./HeaderBackButton.js";
import i from "./HeaderButton.js";
import f from "./HeaderCloseButton.js";
import p from "./Title.js";
const l = Object.assign(t, {
  Header: e,
  Body: o,
  Footer: r,
  Title: p,
  HeaderBackButton: m,
  HeaderCloseButton: f,
  HeaderButton: i
});
export {
  l as default
};
